import { Grid } from "@mui/material";
import * as React from "react";
import {
  Create,
  ReferenceInput,
  useRecordContext,
  AutocompleteInput,
  NumberInput,
  required,
  minValue,
} from "react-admin";
import { TabbedForm, FormTab } from "src/enterprise/ra-rbac";
import { SampleCreateComponent } from ".";
import { InputHelper } from 'src/components/input';

const SampleCreateForm = (props) => {
  const record = useRecordContext(props);
  const filterToQuery = (searchText) => ({ "sku.like": `%${searchText}%` });

  const validateProduct = [required()];
  const validateQuantity = [minValue(0)];

  return (
    <>
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <ReferenceInput
                source="product"
                reference="admin/products"
                filter={{ "sample.product": null, "children.parent": null }}
                perPage={50}
              >
                <AutocompleteInput
                  filterToQuery={filterToQuery}
                  optionText={(record) => record.sku + " " + record.name}
                  label="Parent"
                  size="small"
                  isRequired
                  validate={validateProduct}
                />
              </ReferenceInput>
            </Grid>
            <Grid item sm={12} lg={6}>
              <NumberInput
                source="quantity"
                defaultValue={0}
                required
                validate={validateQuantity}
              />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Reserved" name="reserved">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={12}>
              <NumberInput source="reservedQuantity" defaultValue={0} helperText={<InputHelper text="Use to manually add reserved qunatity." />} />
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </>
  );
};

export const SampleCreate = () => (
  <Create component={SampleCreateComponent}>
    <SampleCreateForm />
  </Create>
);
